import {Controller} from "@hotwired/stimulus";
import {waitForOutletToBeLoaded} from "../../js/functions";

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        litigantId: Number,
        litigantName: String,
        source: String,
        flowFromEmail: Boolean,
    };

    static outlets = [
        'booking--unpaid-booking-modal',
    ];

    async bookingUnpaidBookingModalOutletConnected() {
        if (this.flowFromEmailValue) {
            dataLayer.push({
                "event": "dataLayer.gaEvent",
                "gaEvent": {
                    "category": "Flow",
                    "action": "Flow from email",
                    "label": "unpaid booking",
                },
            });

            await waitForOutletToBeLoaded(() => this.bookingUnpaidBookingModalOutlet);

            this.openModal();
        }
    }

    openModal() {
        this.bookingUnpaidBookingModalOutlet.litigantIdValue = this.litigantIdValue;
        this.bookingUnpaidBookingModalOutlet.litigantNameValue = this.litigantNameValue;
        this.bookingUnpaidBookingModalOutlet.sourceValue = this.sourceValue;
        this.bookingUnpaidBookingModalOutlet.open();
    }
}
